import React, { useEffect, useState, useCallback } from 'react';
import AIProviderCard from './AIProviderCard';
import './aiKeys.css';
import { useTranslation } from 'react-i18next';
import { MODELS, DEFAULT_MODELS } from './ModelSelect';

function buildKeysMapFromConfigs(iaConfigs) {
    const map = {};
    (iaConfigs || []).forEach((item) => {
        const key = item.iaProvider?.toLowerCase();
        if (!key) return;

        const list = MODELS[key] || [];
        const found = list.find((m) => m.type === item.iaModel);

        map[key] = {
            model: found || DEFAULT_MODELS[key] || null,
            enabled: item.active ?? false,
            hasExisting: !!item.token,
            token: item.token || '',
            id: item.id,
        };
    });
    return map;
}

export default function AIKeysContainer({ iaConfigs = [], onChange, onDelete }) {
    const { t } = useTranslation();

    const [keysMap, setKeysMap] = useState(() => buildKeysMapFromConfigs(iaConfigs));
    const [providers, setProviders] = useState([]);
    useEffect(() => {
        setKeysMap((prev) => {
            const next = buildKeysMapFromConfigs(iaConfigs);
            Object.keys(next).forEach((key) => {
                if (prev[key]?.hasExisting && !next[key].hasExisting) {
                    next[key].hasExisting = true;
                    next[key].token = prev[key].token;
                }
            });
            return next;
        });
    }, [iaConfigs]);

    const handleDelete = useCallback((providerName) => {
        setKeysMap((prev) => {
            const next = { ...prev };
            delete next[providerName];
            return next;
        });
        onDelete?.(providerName);
    }, [onDelete]);


    const updateProvider = useCallback((updatedProvider) => {
        setProviders((prev) => {
            const filtered = prev.filter((p) => p.name !== updatedProvider.name);
            return [...filtered, updatedProvider];
        });
    }, []);

    useEffect(() => {
        if (onChange) onChange(providers);
    }, [providers, onChange]);

    return (
        <div className="ai-keys-container">
            <h3>{t('Clé API IA')}</h3>
            <p className="ai-keys-desc">
                {t('Connectez vos propres clés pour utiliser les modèles de votre choix.')}
                {t('Vos clés sont chiffrées et stockées en sécurité')}
            </p>

            <AIProviderCard
                provider="openai"
                title={t('OpenAI - ChatGPT')}
                initialData={keysMap['openai'] || null}
                onChange={updateProvider}
                onDelete={handleDelete}
            />

            <AIProviderCard
                provider="claude"
                title={t('Anthropic - Claude')}
                initialData={keysMap['claude'] || null}
                onChange={updateProvider}
                onDelete={handleDelete}
            />

            <AIProviderCard
                provider="gemini"
                title={t('Gemini')}
                initialData={keysMap['gemini'] || null}
                onChange={updateProvider}
                onDelete={handleDelete}
            />

            <AIProviderCard
                provider="perplexity"
                title={t('Perplexity AI')}
                initialData={keysMap['perplexity'] || null}
                onChange={updateProvider}
                onDelete={handleDelete}
            />
        </div>
    );
}